import React from "react";

import { Box, CampoEstatico, TipoCampoEstatico } from "@intechprev/componentes-web";
import { Contribuicao } from "./Contribuicao";

interface IProps {
  salario: Array<any> | null;
  valorInvalidez: number;
  valorFuneral: number;
}

export const UltimasContribuicoes: React.FC<IProps> = ({
  salario,
  valorInvalidez,
  valorFuneral
}) => {

  let totais = {
    DS_TIPO_CONTRIBUICAO: "Total",
    CONTRIB_PARTICIPANTE: 0,
    CONTRIB_EMPRESA: 0,
    SEQ_CONTRIBUICAO: 0
  }

  if (salario !== null && salario !== undefined && salario.length > 0) {
    return (
      <Box renderRow={true} titulo={"Última Contribuição"} label={`em ${salario[0].MES_REF}/${salario[0].ANO_REF}`}>
        <div className={"table-responsive"}>
          <table className={"table table-striped table-sm"}>

            <caption>
              {"O salário é limitado para a cobertura e a contribuição do benefício de pensão em "}
              <CampoEstatico valor={valorInvalidez} tipo={TipoCampoEstatico.dinheiro} />
              {" e dos benefícios de pecúlio, invalidez e auxílio funeral em "}
              <CampoEstatico valor={valorFuneral} tipo={TipoCampoEstatico.dinheiro} />
              {"."}
            </caption>

            <thead className={"thead-light"}>
              <tr>
                <th>Contribuição</th>
                <th className={"text-right"}>Participante</th>
                <th className={"text-right"}>Patrocinador</th>
                <th className={"text-right"}>%</th>
              </tr>
            </thead>
            <tbody>
              {salario.map((contrib: any, index: number) => {
                totais.CONTRIB_PARTICIPANTE = totais.CONTRIB_PARTICIPANTE + contrib.CONTRIB_PARTICIPANTE;
                totais.CONTRIB_EMPRESA = totais.CONTRIB_EMPRESA + contrib.CONTRIB_EMPRESA;
                totais.SEQ_CONTRIBUICAO = totais.SEQ_CONTRIBUICAO + contrib.SEQ_CONTRIBUICAO;

                return (
                  <Contribuicao contrib={contrib} />
                );
              })}
              <tr key={salario.length}>
                <th>{totais.DS_TIPO_CONTRIBUICAO}</th>
                <th className={"text-right"}>
                  <CampoEstatico valor={totais.CONTRIB_PARTICIPANTE.toLocaleString("pt-Br")} />
                </th>
                <th className={"text-right"}>
                  <CampoEstatico valor={totais.CONTRIB_EMPRESA.toLocaleString("pt-Br")} tipo={TipoCampoEstatico.texto} />
                </th>
                <th className={"text-right"}>
                  <CampoEstatico valor={totais.SEQ_CONTRIBUICAO.toFixed(4).replace('.', ',')} />
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </Box>
    )
  }

  return (
    null
  );
}